// src/components/CardEditor/ReferencesModal.tsx

import React, { useState, useEffect } from 'react';
import { BookOpen, X, Check } from 'lucide-react';
import { ReferencesEditor } from './ReferencesEditor';
import './ReferencesModal.css';

interface ReferencesModalProps {
    isOpen: boolean;
    initialContent: string;
    onSave: (content: string) => void;
    onClose: () => void;
}

export const ReferencesModal: React.FC<ReferencesModalProps> = ({
    isOpen,
    initialContent,
    onSave,
    onClose
}) => {
    const [content, setContent] = useState(initialContent);

    useEffect(() => {
        setContent(initialContent);
    }, [initialContent]);

    if (!isOpen) return null;

    const handleSave = () => {
        onSave(content);
        onClose();
    };

    const handleCancel = () => {
        setContent(initialContent);
        onClose();
    };

    return (
        <div className="refm-overlay" onClick={handleCancel}>
            <div className="refm-content" onClick={(e) => e.stopPropagation()}>
                <div className="refm-header">
                    <div className="refm-title">
                        <BookOpen size={20} />
                        <h2>Referências Bibliográficas</h2>
                    </div>
                    <button className="refm-btn-close" onClick={handleCancel}>
                        <X size={20} />
                    </button>
                </div>

                <div className="refm-body">
                    {/*
                        key={initialContent} força remontagem do ReferencesEditor
                        sempre que o modal abre para um card diferente,
                        garantindo que o useEffect de inicialização rode com o conteúdo correto.
                    */}
                    <ReferencesEditor
                        key={initialContent}
                        content={content}
                        setContent={setContent}
                    />
                </div>

                <div className="refm-footer">
                    <button className="refm-btn refm-btn-cancel" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <button className="refm-btn refm-btn-save" onClick={handleSave}>
                        <Check size={16} />
                        <span>Salvar Referências</span>
                    </button>
                </div>
            </div>
        </div>
    );
};